import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, _, u ) => {
	return {

		growthPageTabsContainer: {
			"& .MuiBox-root": {
				padding: "1rem 0 !important"
			},
			[u.smallerThan ( "md" )]: {
				"& .MuiBox-root": {
					padding: "1.5rem 0"
				},
				fontSize : "0.8rem",
				margin   : "2rem 0",
				width    : "100%"
			},
			margin   : "2rem auto",
			fontSize : "1rem",
			width    : "90%"
		},
		tabText: {
			// width            : "10rem",
			width            : "15%",
			"&.Mui-selected" : {
				fontWeight : "500",
				fontSize   : "1.3rem"
			},
			[u.smallerThan ( "md" )]: {
				"&.Mui-selected": {
					fontWeight : "500",
					fontSize   : "1rem"
				},
			 fontSize: "1rem"

		 },
			color        : "gray",
			fontSize     : "1.3rem",
			borderRadius : "5px 5px 0 0"
		},
		totalText: {
			height: "1.5rem"
		}
	};
} );